import { useTranslation } from 'react-i18next'
import { FormikErrors, FormikTouched } from 'formik'
import { type FocusEvent } from 'react'

import classes from '../LogVolunteeringActivityForm.module.scss'
import type { LogVolunteeringActivityFormFields } from '../../LogVolunteeringActivity.types'

import { FormField, Radio } from '@percent/lemonade'

type WorkingHoursCheckFieldSetProps = Readonly<{
  values: LogVolunteeringActivityFormFields
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<LogVolunteeringActivityFormFields>>
  setFieldTouched: (
    field: string,
    touched?: boolean | undefined,
    shouldValidate?: boolean | undefined
  ) => Promise<void | FormikErrors<LogVolunteeringActivityFormFields>>
  touched: FormikTouched<LogVolunteeringActivityFormFields>
  errors: FormikErrors<LogVolunteeringActivityFormFields>
  handleBlur: <A = HTMLInputElement>(e: FocusEvent<A>) => void
  required: boolean
}>

export function WorkingHoursCheckFieldSet({
  touched,
  errors,
  values,
  setFieldTouched,
  setFieldValue,
  handleBlur,
  required
}: WorkingHoursCheckFieldSetProps) {
  const { t } = useTranslation()

  const WORKING_HOURS_CHECK_OPTIONS = [
    {
      value: true,
      label: t('workplace_giving.common.yes')
    },
    {
      value: false,
      label: t('workplace_giving.common.no')
    }
  ]

  return (
    <div className={classes.WorkingHoursCheckField}>
      <FormField
        label={t('workplace_giving.volunteering.activityForm.workingHoursCheck.label')}
        necessity={required ? 'required' : 'optional'}
        data-testid="workingHoursCheckField"
        status={touched.duringWorkingHours && errors.duringWorkingHours ? 'danger' : 'default'}
        statusMessage={errors.duringWorkingHours}
      >
        <div className={classes.RadioGroup}>
          {WORKING_HOURS_CHECK_OPTIONS.map(option => (
            <Radio
              key={String(option.value)}
              id={`privacy-${option.value ? 'public' : 'private'}`}
              name="privacy"
              label={option.label}
              value={String(option.value)}
              checked={values.duringWorkingHours === option.value}
              onBlur={handleBlur}
              onChange={() => {
                setFieldValue('duringWorkingHours', option.value)
                setFieldTouched('duringWorkingHours')
              }}
              data-testid={`workingHoursCheck-${option.value ? 'inHours' : 'afterHours'}`}
            />
          ))}
        </div>
      </FormField>
    </div>
  )
}
